module.exports = __webpack_public_path__ + "img/mobapp-10.1a27413.png";